export const valueProposition = {
  title: "¿Por qué elegir Gándara?",
  subtitle: "Tres pilares fundamentales que definen nuestra propuesta educativa",
  items: {
    montessori: {
      title: "Pedagogía Activa Montessori",
      description: "Ambientes preparados, materiales manipulativos y respeto por los ritmos individuales de aprendizaje"
    },
    nature: {
      title: "Naturaleza y Espacios",
      description: "Más de 5.000 m² de instalaciones con huerta, áreas verdes y conexión constante con el entorno natural"
    },
    community: {
      title: "Comunidad Educativa",
      description: "Ratios reducidas (1:12) y acompañamiento cercano que permite atención personalizada"
    }
  }
};
